import { Footer } from '../components/Footer';
import { Loader } from '../components/Loader';
import CheckoutHeader from '../components/checkout-header';
import Alert from '../components/ui/Alert';
import { CheckoutProvider } from '../context/checkout.context';
import { useInitCheckout } from '../hooks/init-checkout.hook';
import { testId } from '../utils';
import { useTranslation } from '@rpi/i18n';
import clsx from 'clsx';
import { Outlet } from 'react-router-dom';

export const CheckoutLayout = () => {
  const { t } = useTranslation(undefined, { keyPrefix: 'route.auth' });
  const { initLoading, initError, checkoutData } = useInitCheckout();

  return (
    <div className={clsx('flex flex-col h-full w-full sm:mb-8 md:pb-0')}>
      <CheckoutHeader />
      {initError && (
        <div className="flex justify-center items-center py-20">
          <Alert {...testId('init-checkout-error')} variant="error">
            {t('generic_error')}
          </Alert>
        </div>
      )}
      {initLoading && (
        <div className="flex justify-center items-center py-20">
          <Loader size="xl" />
        </div>
      )}
      {checkoutData && !initLoading && (
        <CheckoutProvider initialCheckoutData={checkoutData}>
          <Outlet />
        </CheckoutProvider>
      )}
      <Footer className="md:px-20" />
    </div>
  );
};
